<template>
  <div id="activity">
    <el-timeline>
      <el-timeline-item v-for="(activity, index) in activitydata" :key="index" :timestamp="activity.operDate"
        placement="top" color="#6a91b8">
        <el-card class="activitybgc">
          <h4>{{ activity.operUserName }}</h4>
          <span class="timeStatus">
            状态：
            <el-button type="text">{{ activity.queStatusNew }}</el-button>
          </span>
          <p class="des" :title="activity.content">
            <span>说明：</span>
            <span class="content">{{ activity.content }}</span>
          </p>
        </el-card>
      </el-timeline-item>
    </el-timeline>
  </div>
</template>

<script>
import requestIssueMg from "@/CommonDP/service/question-service";
export default {
  props: ["rowData"],
  data() {
    return {
      activitydata: {}
    };
  },
  created() {
    this.getTimeLine();
  },
  methods: {
    async getTimeLine() {
      try {
        const res = await requestIssueMg.getDrawingQuestionRecord(this.rowData.questionId);
        if (res.result === "0") {
          this.activitydata = res.data;
        }
      } catch (error) {}
    }
  }
};
</script>

<style lang="scss" scoped>
#activity {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  overflow-y: auto;
  margin-top: 10px;
  padding: 8px 16px;
  /deep/ .el-timeline-item {
    padding-bottom: 5px;
  }
  /deep/ .el-card__body {
    background: #f3f3f3;
    border-color: #f3f3f3;
    padding-top: 10px;
    padding-bottom: 10px;
  }
  /deep/ .el-card {
    background: #f3f3f3;
  }
  .des {
    width: 100%;
    line-height: 25px;
    display: flex;
    flex-direction: row;
    .content {
      width: calc(100% - 50px);
      display: block;
      word-wrap: break-word;
    }
  }
}
#activity::-webkit-scrollbar {
  width: 6px;
}
#activity::-webkit-scrollbar-thumb {
  border-radius: 3px;
  box-shadow: inset 0 0 4px rgba(0, 0, 0, 0.3);
  background-color: #e8e8e8;
}
#activity::-webkit-scrollbar-track {
  box-shadow: inset 0 0 4px rgba(0, 0, 0, 0.3);
  background-color: #fff;
  border-radius: 3px;
}
</style>
